module.exports = __webpack_public_path__ + "media/images/country_flags/fo-614df61cd711c939ea860581ce3f8dd0.png";